import { Component } from '@angular/core'

import { GenericListComponent } from '../../framework/generic-list/generic-list.component'
import { TillService, Till } from '../till.service'

@Component({
  selector: 'app-till-list',
  templateUrl: './till-list.component.html',
  styleUrls: ['../../framework/generic-list/generic-list.component.css']
})
export class TillListComponent extends GenericListComponent<Till> {

  constructor(protected override service: TillService) { super(service) }
}
